import { APP_CONFIG } from "../constants/global-variables.js";

export async function login(username, password) {
  return new Promise((resolve, reject) => {

    var formdata = new FormData();
    formdata.append("username", username);
    formdata.append("password", password);
  
    const url = `${APP_CONFIG.URL.apiBasePath}login`;
    try {
      var xhr = new XMLHttpRequest();
      xhr.responseType = 'json';
      xhr.open('POST', url, true);
      xhr.onload = function () {
        if (this.response && this.response.error === true) {
          reject(this.response);
        }
        resolve(this.response);
      };
      xhr.send(formdata);
    } catch (err) {
      reject(err);
    }
  });
}
